<template>
    <page-title :title="$t('monitoring.title')"></page-title>

    <warning-banner class="my-4" v-if="critical > 0">
        {{ $t('monitoring.criticalWarning', {amount: critical}) }}
        {{ ' ' }}
        <link-button @click="routeToAttentianable('critical')">
            {{ $t('monitoring.gotoList') }}
        </link-button>

    </warning-banner>

    <warning-banner class="my-4" v-if="cancellationRequests > 0">
        {{ $t('monitoring.cancellationWarning', {amount: cancellationRequests}) }}
        {{ ' ' }}
        <link-button @click="routeToAttentianable('requested_cancellation')">
            {{ $t('monitoring.gotoList') }}
        </link-button>
    </warning-banner>
    <div>
        <range-selector v-model="range"></range-selector>
        <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            <div v-for="item in stats" :key="item.id"
                 class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <dt>
                    <p class="text-sm font-medium text-gray-500 truncate">{{ $t('monitoring.' + item.name) }}</p>
                </dt>
                <dd class="pb-6 flex items-baseline sm:pb-7">
                    <p
                        :class="item.type === 'warn' ? 'text-red-500' : 'text-gray-900'"
                        class="text-2xl font-semibold">
                        {{ item.stat }}
                    </p>

                    <div class="absolute bottom-0 inset-x-0 bg-gray-50 px-2 py-2 sm:px-2">
                        <div class="text-sm">
                            <link-button @click="routeToOrders(item.filter)">
                                {{ $t('monitoring.viewMore') }}
                            </link-button>
                        </div>
                    </div>
                </dd>
            </div>
        </dl>
    </div>
</template>

<script>
import PageTitle from "@/Shared/Components/PageTitle";
import AppLayout from "@/Layouts/AppLayout";
import {ArrowSmallDownIcon, ArrowSmallUpIcon} from '@heroicons/vue/20/solid'
import {pickBy, throttle} from "lodash";
import {ref} from "vue";
import RangeSelector from "@/Shared/Components/RangeSelector";
import WarningBanner from "@/Shared/Components/WarningBanner";
import LinkButton from "@/Jetstream/LinkButton";
import moment from "moment";

export default {
    props: [
        'range',
        'stats',
        'critical',
        'cancellationRequests'
    ],
    components: {
        LinkButton,
        WarningBanner,
        RangeSelector,
        PageTitle,
        ArrowSmallDownIcon,
        ArrowSmallUpIcon,
    },
    layout: AppLayout,
    setup(props) {
        const range = ref(props.range.split(',').map((date) => moment(date).toDate()));
        return {
            range
        }
    },
    watch: {
        range: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "range": this.range.map((d) => d != null ? d.toISOString() : null).join(','),
                };
                this.$inertia.get(this.route("sales.monitoring.index"), pickBy(query), {
                    preserveState: true
                });
            }, 700)
        }
    },
    methods: {
        routeToOrders(state) {
            let query = {
                "filter[from]": this.range ? this.range[0] : null,
                "filter[to]": this.range ? this.range[1] : null,
                "filter[fulfillment]": state,
            };
            this.navigate(query);
        },
        navigate(query) {
            this.$inertia.get(this.route("sales.orders.index"), pickBy(query), {});
        },
        routeToAttentianable(state) {
            let query = {};
            if (state === 'critical') {
                query['filter[critical]'] = true
            }

            if (state === 'requested_cancellation') {
                query['filter[fulfillment]'] = 'requested_cancellation'
            }
            this.navigate(query);
        },
    }
}
</script>

<style scoped>

</style>
